import React, { useState, useEffect } from "react";
import { apiRequest } from "../utils/api";
import { useAlert } from "../components/AlertModal";
import useDebouncedEffect from "../hooks/useDebouncedEffect";
import "../styles/ScrapeSingle.css";

const ScrapeSingle = () => {
  const [targetUrl, setTargetUrl] = useState("");
  const [targetSurugaya, setTargetSurugaya] = useState("");
  const [editData, setEditData] = useState(null);
  const [hasEdited, setHasEdited] = useState(false);
  const [categories, setCategories] = useState([]);
  const { showAlert } = useAlert();
  const [isScrapingMetalbox, setIsScrapingMetalbox] = useState(false);
  
  const handleChange = (field, value) => {
    setEditData(prev => ({
      ...prev,
      [field]: value,
    }));
    setHasEdited(true);
  };

  useDebouncedEffect(() => {
    if (hasEdited && editData?.id) {
      handleInventoryUpdate(editData.id, editData);
      setHasEdited(false); // PATCH完了後はリセット
    }
  }, [editData], 500); // 0.5秒間隔で発火
  
  const handleInventoryUpdate = async (itemId, updates) => {
    try {
      await apiRequest(`inventory/inventory/${itemId}/`, "PATCH", updates);
      console.log("更新成功");
    } catch (error) {
      console.error("Inventory更新失敗:", error);
      showAlert("商品情報の更新に失敗しました");
    }
  };    

  const handleCategoryChange = async (e) => {
    const categoryId = Number(e.target.value);

    // フロント表示を即時反映
    const selectedCategory = categories.find(cat => cat.id === categoryId);
    setEditData(prev => ({
      ...prev,
      category: selectedCategory || null
    }));

    // サーバーにPATCHで送信
    try {
      await handleInventoryUpdate(editData.id, { category_id: categoryId });
    } catch (error) {
      console.error("カテゴリ更新エラー:", error);
      showAlert("カテゴリの更新に失敗しました");
    }
  };
  
  const handleImageError = async (e, sku) => {
    // ① まだpasomaru画像試してないなら、pasomaruからダウンロードして再試行
    if (!e.target.dataset.retry) {
      try {
        await fetch(`/inventory/download_pasomaru_image/${sku}/`);  // ここでバックエンドAPIを叩く
        e.target.src = `/media/product_images/${sku}.jpg`;    // 再トライ
        e.target.dataset.retry = "true";  // 再リトライした印をつける
      } catch (error) {
        console.error("パソマル画像ダウンロード失敗:", error);
        e.target.src = "/media/system_images/noimage.jpg"; // 最後のデフォルト
      }
    } else {
      // ② それでもダメならNoImage
      e.target.src = "/media/system_images/noimage.jpg";
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiRequest("inventory/categorys/", "GET");
        setCategories(response);
      } catch (error) {
        console.error("カテゴリー取得失敗:", error);
      }
    };
    fetchCategories();
  }, []);

  const reloadEditData = async () => {
    try {
      const data = await apiRequest(`inventory/inventory/${editData.id}/`);
      setEditData(data);
      showAlert("最新情報を再取得しました。");
    } catch (err) {
      console.error("再取得失敗:", err);
      showAlert("最新データの取得に失敗しました。");
    }
  };

  const handleScrapeMetalbox = async (e) => {
    e.preventDefault();
    if (isScrapingMetalbox) return;

    setIsScrapingMetalbox(true);
    try {
      const response = await apiRequest("inventory/scrape_one/", "POST", {
        targeturl: targetUrl.trim(),
      });
      if (!response?.inventory_id) {
        showAlert(response?.message || "METALBOXスクレイピング失敗（IDなし）");
        return;
      }
      const detailData = await apiRequest(
        `inventory/inventory/${response.inventory_id}/`, "GET"
      );
      setEditData(detailData);
    } catch (error) {
      console.error("METALBOXスクレイピングエラー:", error);
      showAlert(error?.details?.message || "METALBOXスクレイピング失敗");
    } finally {
      setIsScrapingMetalbox(false);
    }
  };

  const handleScrapeSurugaya = async (e) => {
    e.preventDefault();
    try {
      const response = await apiRequest("inventory/scrape_surugaya/", "POST", { targetsurugaya: targetSurugaya });

      if (response.inventory_id) {
        const inventoryId = response.inventory_id;
        const detailData = await apiRequest(`inventory/inventory/${inventoryId}/`);
        setEditData(detailData);
      } else {
        showAlert("駿河屋スクレイピング失敗（IDなし）");
      }
    } catch (error) {
      console.error("駿河屋 スクレイピングエラー:", error);
      showAlert("駿河屋スクレイピング失敗");
    }
  };

 

  return (
    <div className="ScrapeSingle-container">
      <h1 className="ScrapeSingle-title">個別登録</h1>

      <div className="ScrapeSingle-scrape-forms">
        <form onSubmit={handleScrapeMetalbox} className="ScrapeSingle-form">
          <label>METALBOX URL:</label>
          <input
            type="text"
            value={targetUrl}
            onChange={(e) => setTargetUrl(e.target.value)}
            required
          />
          <button type="submit" disabled={isScrapingMetalbox}>
            {isScrapingMetalbox ? "METALBOX取得中..." : "スクレイピング開始"}
          </button>
        </form>

        <form onSubmit={handleScrapeSurugaya} className="ScrapeSingle-form">
          <label>駿河屋版 URL:</label>
          <input
            type="text"
            value={targetSurugaya}
            onChange={(e) => setTargetSurugaya(e.target.value)}
            required
          />
          <button type="submit">スクレイピング開始</button>
        </form>
      </div>

      {editData && (
        <div className="ScrapeSingle-edit-area">
          <h2>編集　<label onClick={reloadEditData}>🔄</label></h2>
        <div className="ScrapeSingle-edit-container">
          {/* 左側 */}
          <div className="ScrapeSingle-image">
            <img
              src={`/media/product_images/${editData.sku}.jpg`}
              alt="商品画像"
              onError={(e) => handleImageError(e, editData.sku)}
            />
          </div>
          <div className="ScrapeSingle-edit-right">
          {/* 1行目：商品名 */}
          <div className="ScrapeSingle-row">
            <label>商品名:</label>
            <input type="text" value={editData.item_name || ""} onChange={(e) => handleChange("item_name", e.target.value)} />
          </div>

          {/* 2行目：ふりがな */}
          <div className="ScrapeSingle-row">
            <label>ふりがな:</label>
            <input type="text" value={editData.furigana || ""} onChange={(e) => handleChange("furigana", e.target.value)} />
          </div>

          {/* 3行目：メーカー、メーカーふりがな */}
          <div className="ScrapeSingle-row ScrapeSingle-multiple">
            <div>
              <label>メーカー:</label>
              <input type="text" value={editData.manufacturer || ""} onChange={(e) => handleChange("manufacturer", e.target.value)} />
            </div>
            <div>
              <label>メーカーふりがな:</label>
              <input type="text" value={editData.manufacturer_furigana || ""} onChange={(e) => handleChange("manufacturer_furigana", e.target.value)} />
            </div>
          </div>

          {/* 4行目：JAN、SKU、発売日 */}
          <div className="ScrapeSingle-row ScrapeSingle-multiple">
            <div>
              <label>JAN:</label>
              <input type="text" value={editData.jan || ""} onChange={(e) => handleChange("jan", e.target.value)} />
            </div>
            <div>
              <label>SKU:</label>
              <input type="text" value={editData.sku || ""} disabled />
            </div>
            <div>
              <label>発売日:</label>
              <input type="date" value={editData.release_date || ""} onChange={(e) => handleChange("release_date", e.target.value)} />
            </div>
          </div>

          {/* 5行目：タイトル、タイトル略称1、タイトル略称2 */}
          <div className="ScrapeSingle-row ScrapeSingle-multiple">
            <div>
              <label>タイトル:</label>
              <input type="text" value={editData.title || ""} onChange={(e) => handleChange("title", e.target.value)} />
            </div>
            <div>
              <label>タイトル略1:</label>
              <input type="text" value={editData.title_abb || ""} onChange={(e) => handleChange("title_abb", e.target.value)} />
            </div>
            <div>
              <label>タイトル略2:</label>
              <input type="text" value={editData.title_abb2 || ""} onChange={(e) => handleChange("title_abb2", e.target.value)} />
            </div>
          </div>

          {/* 6行目：カテゴリ、ジャンル1、ジャンル2、その他 */}
          <div className="ScrapeSingle-row ScrapeSingle-multiple">
            <div>
              <label>カテゴリー:</label>
              <select
                value={editData.category?.id || ""}
                onChange={handleCategoryChange}
              >
                <option value="">選択してください</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.category_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label>ジャンル1:</label>
              <input type="text" value={editData.genre1 || ""} onChange={(e) => handleChange("genre1", e.target.value)} />
            </div>
            <div>
              <label>ジャンル2:</label>
              <input type="text" value={editData.genre2 || ""} onChange={(e) => handleChange("genre2", e.target.value)} />
            </div>
            <div>
              <label>その他:</label>
              <input type="text" value={editData.etc || ""} onChange={(e) => handleChange("etc", e.target.value)} />
            </div>
          </div>

          {/* 7行目：スイッチ類 */}
          <div className="ScrapeSingle-row ScrapeSingle-multiple">
            <div>
              <label>画像あり:</label>
              <input type="checkbox" checked={editData.picture_switch || false} onChange={(e) => handleChange("picture_switch", e.target.checked)} />
            </div>
            <div>
              <label>CSV出力:</label>
              <input type="checkbox" checked={editData.csv_switch || false} onChange={(e) => handleChange("csv_switch", e.target.checked)} />
            </div>
          </div>

          {/* 8行目：競合店 */}
          <div className="ScrapeSingle-competitor">
            <h3>競合店</h3>
            <div className="ScrapeSingle-competitor-area" >
            {editData.competitorstore_set?.map((store) => (
              <div key={store.id}>
                {store.store_name} (ID: {store.competitor_productid})
              </div>
            ))}
            </div>
            </div>  
          </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScrapeSingle;
